import React, { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Radio, RadioProps } from '../Radio/Radio';

import styles from './Checkbox.module.scss';

export type CheckboxProps = RadioProps;

/**
 * Component that represents a checkbox with a label.
 * This is extension of Radio component so it is better to address
 * `Radio` documentation for more details.
 */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((radioProps, ref) => {
  return (
    <Radio {...radioProps} ref={ref} styles={styles} type="checkbox" customMark={<FontAwesomeIcon icon="check" />} />
  );
});

Checkbox.displayName = 'Checkbox';
